/**
 * @desc Yung-海外自营仓一键入库，履约系统调用，其他系统勿调,一键入库入口统一为履约系统
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InPlanMasterOneClickInboundDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/inMaster/oneClickInbound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
